/** Backend risk values returned by the BFF. */
export const RiskBackendValue = {
  Acceptance: 0,
  Control: 1,
  Damage: 2,
  None: 3
} as const;

export enum DiseaseRiskQueryKey {
  GET_LAST_SPRAY = 'getLastSprayToDiseaseRisk',
  GET_ACCUMULATED_RAINFALL = 'getAccumulatedToDiseaseRisk',
  GET_WEATHER_DATA = 'getWeatherDataToDiseaseRisk',
  GET_SPRAY_WINDOW_DAILY_SUMMARY = 'getSprayWindowDailySummary'
}

export const RECOMMENDATION_NOTES_KEYS = {
  all: ['recommendation-notes'] as const,
  lists: () => [...RECOMMENDATION_NOTES_KEYS.all, 'list'] as const,
  list: (propertyId: string, seasonId: string) => [...RECOMMENDATION_NOTES_KEYS.lists(), propertyId, seasonId] as const
};

export const RECOMMENDATION_NOTES_MUTATION_KEYS = {
  all: ['recommendation-notes'] as const,
  create: () => [...RECOMMENDATION_NOTES_MUTATION_KEYS.all, 'create'] as const
};

export const RECOMMENDATION_NOTES_GROUP_KEYS = {
  all: ['recommendation-notes-group'] as const,
  lists: () => [...RECOMMENDATION_NOTES_GROUP_KEYS.all, 'list'] as const,
  list: (seasonId: string) => [...RECOMMENDATION_NOTES_GROUP_KEYS.lists(), seasonId] as const
};

export const RECOMMENDATION_NOTES_GROUP_MUTATION_KEYS = {
  all: ['recommendation-notes-group'] as const,
  create: () => [...RECOMMENDATION_NOTES_GROUP_MUTATION_KEYS.all, 'create'] as const,
  update: () => [...RECOMMENDATION_NOTES_GROUP_MUTATION_KEYS.all, 'update'] as const
};

export enum RiskColors {
  NO_DATA = 'transparent',
  NONE = '#C1C5C8',
  ACCEPTANCE = '#90D6AA',
  CONTROL = '#FFA858',
  DAMAGE = '#CF3537'
}

export enum Disease {
  YELLOW_RUST = 'Yellow Rust',
  BROWN_RUST = 'Brown Rust',
  SEPTORIA = 'Septoria',
  POWDERY_MILDEW = 'Powdery Mildew',
  FUSARIUM = 'Fusarium',
  RHYNCHOSPORIUM = 'Rhyncho-sporium',
  RAMULARIA = 'Ramularia',
  LEAF_RUST = 'Leaf Rust',
  NET_BLOTCH = 'Net Blotch',
  EYESPOT = 'Eyespot'
}
